import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ConsultaList } from '../shared/model/core/ConsultaList.model';
import { Denuncia } from '../shared/model/denuncias/denuncia.model';
import { DenunciaComentario } from '../shared/model/denuncias/denuncia-comentario.model';
import { DenunciaHistorial } from '../shared/model/denuncias/denuncia-historial.model';
import { DenunciaDashboard } from '../shared/model/denuncias/denuncia-dashboard.model';
import { CategoriaDenuncia } from '../shared/model/denuncias/categoria-denuncia.model';
import { DenunciaEvidencia } from '../shared/model/denuncias/denuncia-evidencia.model';
import { ConfiguracionGeneral } from '../shared/model/emision/configuracionGeneral.model';
import { UrlConstantes } from '../utilerias/constantes/urlconstantes';
import { EstadoPublicoDenuncia, RespuestaAltaDenuncia } from './evidencia-permitida';

const API_URL = environment.apiUrl;

@Injectable({ providedIn: 'root' })
export class DenunciasService {

  constructor(private http: HttpClient) {}

  // ── PÚBLICOS (sin token) ─────────────────────────────────────────────────────

  /** Responde solo { pCodRetorno, pMensaje, codigoSeguimiento, tokenCarga }. */
  registrarDenuncia(denuncia: Denuncia): Observable<RespuestaAltaDenuncia> {
    return this.http.post<RespuestaAltaDenuncia>(
      API_URL + UrlConstantes.DENUNCIA_REGISTRAR, denuncia
    );
  }

  /** Solo código, estatus y fechas: nunca hechos ni datos del denunciante. */
  consultarEstadoDenuncia(codigoSeguimiento: string): Observable<EstadoPublicoDenuncia> {
    return this.http.post<EstadoPublicoDenuncia>(
      API_URL + UrlConstantes.DENUNCIA_CONSULTAR_ESTADO,
      { codigoSeguimiento }
    );
  }

  consultarCategorias(): Observable<ConsultaList<CategoriaDenuncia>> {
    return this.http.post<ConsultaList<CategoriaDenuncia>>(
      API_URL + UrlConstantes.DENUNCIA_CATEGORIAS, {}
    );
  }

  uploadEvidencia(data: FormData): Observable<DenunciaEvidencia> {
    return this.http.post<DenunciaEvidencia>(
      API_URL + UrlConstantes.DENUNCIA_UPLOAD_EVIDENCIA,
      data
    );
  }

  // ── ADMIN (requieren token) ──────────────────────────────────────────────────

  consultarDenunciasKanban(filtro: ConsultaList<Denuncia>): Observable<ConsultaList<Denuncia>> {
    return this.http.post<ConsultaList<Denuncia>>(
      API_URL + UrlConstantes.DENUNCIA_CONSULTAR_KANBAN, filtro
    );
  }

  consultarDenunciasTabla(filtro: ConsultaList<Denuncia>): Observable<ConsultaList<Denuncia>> {
    return this.http.post<ConsultaList<Denuncia>>(
      API_URL + UrlConstantes.DENUNCIA_CONSULTAR_TABLA, filtro
    );
  }

  consultarDetalle(req: Denuncia): Observable<Denuncia> {
    return this.http.post<Denuncia>(
      API_URL + UrlConstantes.DENUNCIA_CONSULTAR_DETALLE, req
    );
  }

  actualizarEstatus(req: Denuncia): Observable<Denuncia> {
    return this.http.post<Denuncia>(
      API_URL + UrlConstantes.DENUNCIA_ACTUALIZAR_ESTATUS, req
    );
  }

  asignarUsuario(req: Denuncia): Observable<Denuncia> {
    return this.http.post<Denuncia>(
      API_URL + UrlConstantes.DENUNCIA_ASIGNAR_USUARIO, req
    );
  }

  guardarComentario(comentario: DenunciaComentario): Observable<DenunciaComentario> {
    return this.http.post<DenunciaComentario>(
      API_URL + UrlConstantes.DENUNCIA_GUARDAR_COMENTARIO, comentario
    );
  }

  consultarDashboard(filtro: ConsultaList<Denuncia>): Observable<DenunciaDashboard> {
    return this.http.post<DenunciaDashboard>(
      API_URL + UrlConstantes.DENUNCIA_DASHBOARD, filtro
    );
  }

  consultarHistorial(req: Denuncia): Observable<ConsultaList<DenunciaHistorial>> {
    return this.http.post<ConsultaList<DenunciaHistorial>>(
      API_URL + UrlConstantes.DENUNCIA_HISTORIAL, req
    );
  }

  /** El servidor la busca por id (con el tenant de la sesión); ruta y tipo ya no viajan. */
  consultarEvidenciaImg(evidencia: DenunciaEvidencia): Observable<Blob> {
    return this.http.post(
      API_URL + UrlConstantes.DENUNCIA_EVIDENCIA_IMG, { id_evidencia: evidencia.id_evidencia },
      { responseType: 'blob' }
    );
  }

  consultarCorreosCopia(): Observable<ConsultaList<ConfiguracionGeneral>> {
    return this.http.post<ConsultaList<ConfiguracionGeneral>>(
      API_URL + UrlConstantes.DENUNCIA_CORREOS_COPIA, {}
    );
  }

  guardarCorreoCopia(config: ConfiguracionGeneral): Observable<ConfiguracionGeneral> {
    return this.http.post<ConfiguracionGeneral>(
      API_URL + UrlConstantes.DENUNCIA_GUARDAR_CORREO_COPIA, config
    );
  }

  eliminarCorreoCopia(config: ConfiguracionGeneral): Observable<ConfiguracionGeneral> {
    return this.http.post<ConfiguracionGeneral>(
      API_URL + UrlConstantes.DENUNCIA_ELIMINAR_CORREO_COPIA, config
    );
  }
}
